/**
 * Created by Miguel on 23/05/2017
 */
import { Component, HostListener,OnInit, Input, ViewChild,ChangeDetectionStrategy, ViewEncapsulation,SimpleChanges  } from '@angular/core';
import { DomSanitizer,  SafeResourceUrl , SafeHtml } from '@angular/platform-browser';
import { AppDataService }  from '../../../services/app-data.service';
import { CompanyService }  from '../../../services/company.service';
import {RecipeBean} from "../../../beansts/recipe.bean"
import { WalletService }  from '../../../services/wallet.services';
import { TranslationService } from '../../../services/translation.service';
import { WritBean } from '../../../beansts/quests/writ.bean';

declare var $ : any;
declare var Swal: any

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'npc-chatbot-component',
    templateUrl:'npc-chatbot-component.html',
    providers  : [],

  })
export class NpcChatbotComponent implements OnInit {
    public ngOnInit() : any {
    }
    constructor( public _sanitizer: DomSanitizer,public translate: TranslationService,public _appData : AppDataService, public _companyService: CompanyService,public _walletService: WalletService) {
    }
    public npcDialog;
    public questions;
    public dialog;

    public writ;
    public job;
    public userWrit;

    public video;
    public thumbnail;

    //    $('#npcReload').click();
    public reload(){
    let npc=this._appData.npc;
    $('#npcModal').on('hidden.bs.modal',  ()=> {
      this.video=null;
    })
    this.npcDialog={welcome:'buscando',questions:[]}
    this._companyService.getNpcDialog(npc.npcId).get().then(val=>{
      this.npcDialog=val.data();
      this.questions=[]
      this.npcDialog.questions.forEach(v=>{
        if (v.stream) {
          if (this._appData.stream==v.stream){
            this.questions.push(v)          
          }
        }
        else {
          this.questions.push(v)
        }
      });
      if (this.npcDialog.video){
        this.video=this.npcDialog.video+'?autoplay=1&enablejsapi=1';
      }
      else {
        this.video=null;
      }
      this.thumbnail=this.npcDialog.thumbnail;
      if (npc.distance>400){
        Swal.fire({title:'Você está longe da interação',text:'Se aproxime para interagir'})
        return;
      }
      this.dialog=this.npcDialog.welcome
      $('#npcModal').modal("show");     
      if (this.npcDialog.writTest){
        let writ = new WritBean();
        writ.setCompanyService(this._companyService)
        writ.setAppData(this._appData)
        //writ.testJob(this.npcDialog.writTest)
        if (this.npcDialog.writTest.onFail){
          this._companyService.getUserWrit(this._appData.instagramUser,this.npcDialog.writTest.group.toString()).get().then(val=>{
            let wrt=val.data();
            if (wrt){//i have a writ to solve with this question
              let job=wrt.jobs[this.npcDialog.writTest.job];
              if (!job){
                this.dialog=this.npcDialog.writTest.onFail
                this.questions=[]
              }
    
            }
            else{
              this.dialog=this.npcDialog.writTest.onFail
              this.questions=[]
            }
          })
        }
      }
//      else{
  //      this.dialog=this.npcDialog.welcome
        $('#npcModal').modal("show");
    //  }
    })

    }
    public doAction(question){
      switch (question.action.id){
        case 1:{
          break;
        }
        case 2:{
          break;
        }
        case 3:{
          break;
        }
        case 4:{//teleport
          this.sendIframeMessage({
            kind:'updateUserStatus',
            params:{uid:this._appData.instagramUser.uid,state:'stop',location:{x:question.action.param.x,y:question.action.param.y}}
          });          
          break;
        }
        case 5:{//item
          this._companyService.getRecipesRef(this._appData.event).doc(question.action.param.item.toString()).get().then(it=>{
            let item=new RecipeBean();
            item.parse(it.data());
            item.baseQuantity=question.action.param.quantity;
            this._appData.userEventContainer.push(item);
            this._companyService.addToUserContainer(this._appData.instagramUser,item)
          })
          break;
        }
        case 6:{//skill
          break;
        }
        case 7:{//Periodic reward
          let date=new Date();
          let time=date.getTime();
          let param=question.action.param;
          let periodicity=param.periodicity;//em minutos qto tempo tem q passar pra pessoa receber.
          let miliPerid=periodicity*60*1000
          let whatToGain=param.item;
          //find item on inventory
          this._companyService.getLastNPCRequest(this.npcDialog,this._appData.instagramUser).get().then(val=>{
            let data=val.data();
            let canAdd=false;
            let lastClick=0;
            if (!data){
              //nada achado
              canAdd=true;
              lastClick=time;
            }
            else{
              lastClick=data.lastClick;             
              let dif=time-lastClick;//diferenca em milisegundos
              if (dif>miliPerid){
                canAdd=true;
              }            
            }
            if (canAdd){
              let quantity=question.action.param.quantity;
              this._companyService.getRecipesRef(this._appData.event).doc(whatToGain).get().then(it=>{
                let rec=new RecipeBean();
                rec.parse(it.data());
                if (quantity<0){
                    let skill=this._appData.userEventSkills[rec.skillId]
                    quantity=Math.floor(-1*quantity*skill.value);   
                }
                this.addItemToInventory(quantity,rec.toItem(),time,miliPerid)

              });
            }
            else{
              let dif=time-lastClick
              let p=Math.floor((periodicity*1000-dif)/(60*1000))+1
              Swal.fire({title:'Pedido recusado',text:'Você coletou sua gratificação a pouco tempo tem que aguardar '+p+' minutos para tentar novamente'})
            }
  
          })
        }
      }
      if (question.action=='giveItem'){
        let onetime=question.param.onetime;
        let itemid=question.param.id;
        let itemquantity=question.param.quantity;
        let itemName=question.param.name;
        let giver=this.npcDialog.id
        let itemKind=question.param.kind;
        let thumbnail=question.param.thumbnail;
        let where=question.param.where;
        let action=question.param.action;
        let src=question.param.src;
        let itemExist=this._appData.userEventContainer.filter(val=>{
          return val.giver==giver;
        })
        let exists=false;
        if (itemExist.length!=0) {
          exists=true;
        }

        if (onetime){
          if (exists) {
            Swal.fire({title:'Você já recebeu este item',text:'Você já recebeu este item e não pode receber novamente.'})
          }
          else{
            let item={
              objectId:itemid,
              name:itemName,
              kind:itemKind,
              quatity:itemquantity,
              thumbnail:thumbnail,
              giver:giver,
              where:where,
              action:action,
              src:src
            }
            this._companyService.addToUserContainer(this._appData.instagramUser,item).then(val=>{
              this._appData.userEventContainer.unshift(item)
            })
          }
        }
        else{

        }

      }
    }
    public sendIframeMessage(messageKind){
      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage(messageKind, "*");
    }

    public addItemToInventory(quantity,itemToAdd,time,lastClick){

      if (itemToAdd.recipeId=='1634834260810'){
        //need to add quantity lamports to user
        this._walletService.sendLamports(this._appData.instagramUser,quantity).subscribe(val=>{
          this._companyService.getLastNPCRequest(this.npcDialog,this._appData.instagramUser).set({
            lastClick:time,
            oldClick:lastClick
          })
          Swal.fire({title:this.translate.instant('SUCCESS'),text:"Sua bonificação foi acrescentada na sua carteira. Aproveite."})
        });        
      } 
      else{
      }

    }


    public expandLink(){
      this._companyService.openExternalLink(this.video,false)

    }
    public askQuestion(question){
      let welcome=question.welcome
      let onWritComplete=question.onWritComplete;
      let onWritIncomplete=question.onWritIncomplete

      let myDialogNow=this.dialog
      if (question.video){
        this.video=question.video+'?autoplay=1&enablejsapi=1';
      }
      else{
          this.video=null; 
      }
      if (question.thumbnail){
        this.thumbnail=question.thumbnail;

      }

      if (question.id==-1){
        this.questions=this.npcDialog.questions;
        this.dialog=this.npcDialog.welcome 
        if (this.npcDialog.video){
          this.video=this.npcDialog.video+'?autoplay=1&enablejsapi=1';
        }
        if (this.npcDialog.thumbnail){
          this.thumbnail=this.npcDialog.thumbnail;
  
        }
  
      }
      else{
        this.dialog=question.answer;
        if (question.goto){
          let newquestion=this.questions[question.goto]
          if (newquestion.questions){
            this.questions=newquestion.questions
          }
          else{
            this.questions=[];
          }
        }
        else if (question.questions){
          this.questions=question.questions;
        }
        else if (question.link){
          this.questions=this.npcDialog[question.link]
        }
        else{
          this.questions=[];
        }
        let hasBack=false;       
        this.questions.forEach(val=>{
          if (val.id==-1){ hasBack=true;}
        })
        if (question.noBack) hasBack=true;
        if (!hasBack){
          this.questions.push({id:-1,question:"Perguntas anteriores"})
        }
      }
      //solve actions and writs
      if (question.action && !question.rewardAction){
        this.doAction(question)
      } 
      if (question.writ){  //I have a job to give
        let writ=new WritBean();
        writ.setCompanyService(this._companyService)
        writ.setAppData(this._appData)
        writ.giveJob(question.writ);
      }
      if (question.writAssociation){//this question solves a writ
        //check if i have the associated writ to solve
        let writ=new WritBean();
        question.writAssociation.answer=question.question
        question.writAssociation.question=myDialogNow
        if (question.questions){
          question.writAssociation.success=true;
        }
        else{
          question.writAssociation.success=false;
        }

        writ.setCompanyService(this._companyService)
        writ.setAppData(this._appData)
        //writ.associateJob(question.writAssociation,null);
      }
      if (question.writTest){
        let writ=new WritBean();
        writ.setCompanyService(this._companyService)
        writ.setAppData(this._appData)
       // writ.testJob(question.writTest);
      }

      if (question.trigger){
        if (question.trigger.kind=='teleport'){
          this.sendIframeMessage({
            kind:'updateUserStatus',
            params:{uid:this._appData.instagramUser.uid,state:'stop',location:{x:question.trigger.x,y:question.trigger.y,z:question.trigger.z?question.trigger.z:0}}
          });    
        }
      }


  



    }

    //if user has item required, it must be removed from inventory.
    //once removed, the reward action must be done
    public rewardWritCompleted(wrt,question){
        if (wrt.itemReq){
          for (let i=0;i<this._appData.userEventContainer.length;i++){
            let item=this._appData.userEventContainer[i]
            if (item.objectId==wrt.itemReq.id){
                this._appData.userEventContainer.splice(i,1)
                this._companyService.removeFromUserContainer(this._appData.instagramUser,item)
                break; 
            }
  
          }
        }
        if (question.rewardAction){
          this.doAction(question)
        }
        wrt.rewarded=true;
        this._companyService.getUserWrit(this._appData.instagramUser,wrt).set(wrt); 
    }

    public checkWritCompleted(wrt,onWritIncomplete,onWritComplete){
      if (wrt.itemReq.id!=-1){
        //check if item on bag
        let itemfilter=this._appData.userEventContainer.filter(val=>{
          return val.objectId==wrt.itemReq.id;
        })
        if (itemfilter.length>0){
          let myitem=itemfilter[0]
          if (myitem.quantity==wrt.itemReq.quantity){
            //job complete
          }
          else{
            this.dialog=onWritIncomplete;

          }
        }
        else{
          this.dialog=onWritIncomplete;
        }
      }
      else if (wrt.skillReq.id!=-1){
        //check if skill right
        let skillfilter=this._appData.userEventSkills.filter(val=>{
          return val.id==wrt.skillReq.id;
        })
        if (skillfilter.length>0){
          let myskill=skillfilter[0]
          if (myskill.value==wrt.skillReq.quantity){
            //job complete
          }
          else{
            this.dialog=this.npcDialog.onWritIncomplete;

          }
        }
        else{
          this.dialog=onWritIncomplete;
        }

      }
      else{
        this.dialog=onWritIncomplete;

      }
      Swal.fire({title:"O trabalho incompleto",text:"O trabalho '"+wrt.title+"' ainda está incompleto. Termine ele para receber seus pontos."})

    }

    //writ receiver when writ is not complete
    public doWrit(writ,question){
        let update=false;
        let completed=0;
        let jobIndex=question.jobIndex;
        let rewardAction=question.rewardAction;

        if (writ.jobs.length>0){
          for (let i=0;i<writ.jobs.length;i++){
              let job=writ.jobs[jobIndex];
              if (job.completed) {
                completed++;
              }
              else{
                job.completed=true;
                completed++;
                writ.jobs[i]=job;
                update=true;
              }
              if (completed==writ.jobs.length){ writ.completed=true;}
          }
        }
        else{
          writ.completed=true;
          update=true;
        }
        if (writ.completed && rewardAction){
          this.doAction(question);
        }
          if (update){
            this._companyService.getUserWrit(this._appData.instagramUser,writ).set(writ).then(val=>{
                Swal.fire("Trabalho completo!!","Você completou o trabalho: '"+writ.title+"'.");
            }); 
        }        
    }  
}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/npc-modal/npc-chatbot-component.ts